<template>
  <div>
    <!-- PC菜单 start -->
    <div class="menu-1">
      <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect" background-color="#639"
        text-color="#fff" active-text-color="#ffd04b" :router=false class="header">
        <el-menu-item index="/">
          首页
        </el-menu-item>
        <!-- <el-menu-item index="/tools">
          文案工具箱
        </el-menu-item> -->
        <!-- <el-menu-item index="/contact">
          获取账号
        </el-menu-item> -->
<!-- 
        <el-submenu index="/contact">
          <template slot="title">获取账号</template>
          <el-menu-item index="/plans">新购套餐</el-menu-item>
          <el-menu-item index="/contact">联系我们</el-menu-item>
        </el-submenu> -->

        <el-submenu index="/account" v-show="isLogin">
          <template slot="title">个人中心</template>
          <el-menu-item index="/account">我的套餐</el-menu-item>
          <!-- <el-menu-item index="/order">我的订单</el-menu-item> -->
        </el-submenu>

        <!-- <el-menu-item index="/account" v-show="isLogin">
          个人中心
        </el-menu-item> -->
        <!-- <div class="login-btn-box">
          <Login />
        </div> -->
        <div class="text">
          <span>AI文本工具站</span>
        </div>
      </el-menu>
    </div>
    <!-- PC菜单 end -->

    <!-- 移动端菜单 start -->
    <div class="menu-2">
      <el-button icon="el-icon-s-unfold" @click="drawer = true"
        style="margin-left: 16px; display:flex; margin: 10px; float: left;">
        菜单
      </el-button>
      <el-drawer class="drawer" title="菜单" :visible.sync="drawer" :with-header="false" direction="ltr"
        :before-close="handleClose" style="width:600px">
        <el-menu :default-active="activeIndex" :router=false class="el-menu-vertical-demo" @select="handleSelect"
          @close="handleClose" style="width:100%;height: 100%;">
          <el-menu-item index="/">
            <i class="el-icon-menu"></i>
            <span slot="title">AI问答</span>
          </el-menu-item>
          <el-menu-item index="/tools">
            <i class="el-icon-setting"></i>
            <span slot="title">文案工具箱</span>
          </el-menu-item>
          <!-- <el-menu-item index="/contact">
            <i class="el-icon-document"></i>
            <span slot="title">获取账号</span>
          </el-menu-item> -->
          <!-- <el-submenu index="/contact">
            <template slot="title"><i class="el-icon-document"></i>获取账号</template>
            <el-menu-item index="/plans">新购套餐</el-menu-item>
            <el-menu-item index="/contact">联系我们</el-menu-item>
          </el-submenu> -->

          <!-- <el-menu-item index="/account" v-show="isLogin">
            <i class="el-icon-setting"></i>
            <span slot="title">个人中心</span>
          </el-menu-item> -->

          <el-submenu index="/account" v-show="isLogin">
            <template slot="title"><i class="el-icon-setting"></i>个人中心</template>
            <el-menu-item index="/account">我的套餐</el-menu-item>
            <!-- <el-menu-item index="/order">我的订单</el-menu-item> -->
          </el-submenu>
        </el-menu>
      </el-drawer>
      <!-- <div class="login-btn-box">
        <Login />
      </div> -->
    </div>
    <!-- 移动端菜单 end -->


  </div>
</template>
  
<script>
import Login from "@/components/page/Login.vue"
export default {
  name: "MenuBar",
  components: {
    Login,
  },
  data() {
    return {
      drawer: false,
      activeIndex: '/',
      img: '../../assets/images/title.png'
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      if (this.$route.path !== key) {
        this.$router.replace(key)
      }
    },
    goRouter(path) {
      this.$router.replace(path)
    },
    handleClose(done) {
      done();
      this.$refs.loginWindow.close()
    },
  },
  mounted() {
    const path = this.$route.path
    if (path.startsWith('/tools/')) {
      this.activeIndex = '/tools'
    } else {
      this.activeIndex = path
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin
    }
  }
}
</script>
  
<style scoped>
.menu-1>.el-menu {
  padding: 0, 20px;
  background: linear-gradient(to right, transparent 30%, rgba(0, 0, 0, 0.5) 50%, transparent 70%);
  white-space: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0;
}

.el-menu--popup-bottom-start {
  margin-top: 0;
}

.router {
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-weight: bold;
  font-size: 1rem;
  text-decoration: none;
}


.text {
  float: right;
  overflow: hidden;
  height: 60px;
  margin: 0 20px;
  perspective: 1000px;
  font-size: 40px;
  text-shadow: 0px 0px 10px rgba(255, 255, 255, 0.30);
  color: #d7acf7f2;
}

.login-btn-box {
  float: right;
  margin: 0 10px;
  width: 100px;
}

.menu-1 {
  display: block;
}

.menu-2 {
  display: none;
}

@media screen and (max-width: 767px) {
  .menu-1 {
    display: none;
  }

  .menu-2 {
    display: block;
  }

  .el-dialog .loginOutBox {
    width: 90%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/page/MenuBar.vue